export default __webpack_public_path__ + "static/media/hht1_home_img_EP16.12ae83db.png";